import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';

export const headingIconWrapper = css`
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding-right: 6px;

  > svg {
    width: 21px;
    height: 21px;
    color: ${colors.primary.default};
  }
`;

export const blockWrapper = css`
  width: auto;
  min-height: auto;
  box-shadow: none;
  margin-top: 10px;
  color: ${colors.gray.dark};
  border-radius: 5px;
  background-color: ${colors.custom.lightGray50Alternative3};
  position: relative;
`;

export const imageBlockWrapper = css`
  width: 250px;
  height: 250px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const textBlockWrapper = css`
  display: flex;
  align-items: center;
  text-align: center;
`;

export const buttonBlock = css`
  display: flex;
  justify-content: end;
  align-items: center;
  padding: 25px;

  > svg {
    width: 16px;
    height: 16px;
  }
`;

export const blockClose = css`
  position: absolute;
  right: 10px;
  top: 10px;
`;
